<template>
  <div class="max-w-[1000px] my-8">
    <EmailNotificationSettings />
  </div>
</template>

<script setup>
import EmailNotificationSettings from './components/EmailNotificationSettings.vue';
</script>
